import React from 'react';
import { BookADemoButton } from './qbo';

export const LearnMore = () => {
  return (
    <div className="flex flex-column items-center">
      <div className="text-white flex flex-column items-center md:max-w-[70%] text-center gap-4">
        <h1 className="text-6xl font-['Sharp Grotesk'] font-medium m-0 mt-[4rem] md:mt-[8rem]">
          Equipment rental software. Simplified.
        </h1>
        <p className="max-w-[40rem] leading-6 font-light m-0 flex flex-column items-center">
          Use Quipli to manage your rental business and make accounting easy by seamlessly publishing all your
          transactions rental transactions to QuickBooks.
          <div className="w-3/4 text-left">
            <ul>
              <li>Create orders and Quipli and corresponding invoices will automatically be created in QuickBooks</li>
              <li>Customer profiles created in Quipli will automatically be created in QuickBooks</li>
              <li>
                Accept payments in Quipli and those payments are automatically credited to the customer in QuickBooks
              </li>
            </ul>
          </div>
        </p>
        <p className="max-w-[40rem] leading-6 font-light m-0">
          Quipli, the next generation of equipment rental software. Easy to use, simple, modern, and fast. Inventory
          management, e-commerce, service & repair, and much more.
        </p>
        <BookADemoButton />
        <div className="flex flex-row gap-2 md:gap-[6rem] md:m-8 flex-wrap justify-center">
          <div className="flex flex-column items-center gap-2">
            <figure className="m-0">
              <img
                src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/capterra-icon.svg"
                alt="Capterra Icon"
                width="104"
                height="24"
              />
            </figure>
            <div className="flex gap-2 items-center">
              <span>4.9/5</span>
              <figure className="m-0 flex flex-column items-center">
                <img
                  src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/5star-icon.svg"
                  alt="Five Star Icon"
                  width="104"
                  height="20"
                />
              </figure>
            </div>
          </div>
          <div className="flex flex-column items-center gap-2">
            <figure className="m-0">
              <img
                src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/gstar-icon.svg"
                alt="G2star Icon"
                width="84"
                height="24"
              />
            </figure>
            <div className="flex gap-2 items-center">
              <span>5/5</span>
              <figure className="m-0 flex flex-column items-center">
                <img
                  src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/5star-icon.svg"
                  alt="Five Star Icon"
                  width="104"
                  height="20"
                />
              </figure>
            </div>
          </div>
          <div className="flex flex-column items-center gap-2">
            <figure className="m-0">
              <img
                src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/google-icon.svg"
                alt="Google Icon"
                width="78"
                height="24"
              />
            </figure>
            <div className="flex gap-2 items-center">
              <span>5/5</span>
              <figure className="m-0 flex flex-column items-center">
                <img
                  src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/5star-icon.svg"
                  alt="Five Star Icon"
                  width="104"
                  height="20"
                />
              </figure>
            </div>
          </div>
        </div>
      </div>
      <picture className="m-4 md:m-16">
        <source
          media="(min-width: 768px)"
          srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.webp"
        />
        <source
          media="(min-width: 768px)"
          srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.png"
        />
        <source srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental-mob.webp" />
        <source srcSet="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental-mob.png" />
        <img
          className="max-w-full h-[auto]"
          src="https://quipli.com/wp-content/themes/quipli-v2/assets/img/home/quipli-rental.png"
          alt="Rental Software"
          decoding="async"
          width="1691"
          height="1063"
        />
      </picture>
    </div>
  );
};
